import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { MbIconComponent } from '../mb-icon/mb-icon.component';
import { ASSET_CONSTANTS } from '../../../shared/constants/asset-constants';

@Component({
  selector: 'app-mb-image-upload',
  imports: [CommonModule, NzIconModule, MbIconComponent],
  standalone: true,
  templateUrl: './mb-image-upload.component.html',
  // styleUrls: ['./mb-image-upload.component.css'],
})
export class MbImageUploadComponent {
  @Input() placeholder = 'Upload Image';
  @Input() accept = 'image/*';
  @Input() maxSize = 5; // Maximum file size in MB
  @Input() containerClass = '';
  @Input() disabled = false;
  @Input() errorMessage = '';
  @Input() hasError = false;
  @Input() icon = ASSET_CONSTANTS.I_image_upload;
  @Input() set initialImage(value: string | null | undefined) {
    this.initialImageValue = value ?? null;
    if (!this.selectedFile) {
      this.selectedImage = this.initialImageValue;
    }
  }

  @Output() imageSelected = new EventEmitter<string>(); // Emits base64 string
  @Output() fileSelected = new EventEmitter<File>(); // Emits the file object
  @Output() uploadError = new EventEmitter<string>(); // Emits error messages

  selectedImage: string | null = null;
  selectedFile: File | null = null;
  private initialImageValue: string | null = null;

  get containerClasses(): string {
    return `${this.containerClass}`;
  }

  onFileSelect(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.handleFile(file);
    }
  }

  private handleFile(file: File): void {
    // Validate file type
    if (!file.type.startsWith('image/')) {
      const errorMsg = 'Please select a valid image file';
      this.uploadError.emit(errorMsg);
      return;
    }

    // Validate file size
    const fileSizeInMB = file.size / (1024 * 1024);
    if (fileSizeInMB > this.maxSize) {
      const errorMsg = `File size must be less than ${this.maxSize}MB`;
      this.uploadError.emit(errorMsg);
      return;
    }

    // Convert to base64
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      const result = e.target?.result as string;
      this.selectedImage = result;
      this.selectedFile = file;
      this.imageSelected.emit(result);
      this.fileSelected.emit(file);
    };

    reader.onerror = () => {
      const errorMsg = 'Error reading file';
      this.uploadError.emit(errorMsg);
    };

    reader.readAsDataURL(file);
  }

  removeImage(): void {
    this.selectedImage = null;
    this.selectedFile = null;
    this.imageSelected.emit('');
    this.fileSelected.emit(null as any);
  }

  triggerFileInput(): void {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = this.accept;
    fileInput.onchange = (event: any) => {
      const file = event.target.files[0];
      if (file) {
        this.handleFile(file);
      }
    };
    fileInput.click();
  }
}
